import { render, staticRenderFns } from "./PageHabitsTrackerManagerSkeleton.vue?vue&type=template&id=387766b0"
import script from "./PageHabitsTrackerManagerSkeleton.vue?vue&type=script&lang=js"
export * from "./PageHabitsTrackerManagerSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports